module.exports = __webpack_public_path__ + "static/image/history/pc/202010.ver2_0_2.jpg?235a2c36";